'use strict';

exceptionHandler.$inject = ["$provide"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exceptionHandler = exceptionHandler;
/*@ngInject*/
function exceptionHandler($provide) {
    $provide.decorator('$exceptionHandler', ["$delegate", "$window", "config", function ($delegate, $window, config) {
        'ngInject';

        return function (exception, cause) {
            if (config.env === 'dev' || config.env === 'acc' || config.env === 'prod' /* || config.env === 'local'*/) {
                    //TODO
                    if ($window.trackJs) {
                        // Track error and log anything else of interest.
                        $window.trackJs.track(exception);
                    }
                }
            if (config.env === 'local' || config.env === 'dev') {
                // In *non-production* environments you may still want the error sent to the console.
                // You can delegate to the original handler (console.error) if you'd like.
                // Warning, this can cause double tracking of errors, so do not use in production.
                $delegate(exception, cause);
            }
        };
    }]);
}


//////////////////
// WEBPACK FOOTER
// ./common/core/exceptionHandler.js
// module id = 702
// module chunks = 0